import React from 'react';
import { Card } from 'semantic-ui-react';
import MessageLogTable from '../../components/MessageLogTable';

const MessageLog = () => {
  return (
    <div className='dashboard-container'>
      <Card fluid className='chart-card'>
        <Card.Content>
          <Card.Header className='header'>消息日志</Card.Header>
          <p style={{ color: '#8a919f', marginTop: 0 }}>
            公众号模板消息 / 邮件 / 短信的发送记录与公众号关联（关注、取消关注）反向回调记录。
            为避免隐私数据长期留存，网关只记录脱敏后的接收方，不记录正文。
          </p>
          <MessageLogTable />
        </Card.Content>
      </Card>
    </div>
  );
};

export default MessageLog;
